import { ItemProgress } from '@/models/DNDOrdenation';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { DragIcon } from '../../../../../icons';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { Draggable } from '@hello-pangea/dnd';
import { ActivityMode } from '@/models/_deprecated/ActivityProgress';
import DNDItemContainer from '../../DNDItem/DNDItemContainer';

interface DNDOrdenationItemProgressProps {
  dndOrdenationItemProgress: ItemProgress;
  index: number;
  activityMode: ActivityMode;
  answerOrder?: number;
  isDisabled: boolean;
}

export default function DNDOrdenationItemProgress({
  dndOrdenationItemProgress,
  index,
  activityMode,
  answerOrder,
  isDisabled,
}: DNDOrdenationItemProgressProps) {
  const { text, image, altText } = dndOrdenationItemProgress.item;

  const shouldShowAnswer = activityMode === 'answerkey' && !!answerOrder;

  const isCorrect = index + 1 === answerOrder;

  return (
    <Draggable
      key={dndOrdenationItemProgress.id}
      isDragDisabled={isDisabled}
      draggableId={String(dndOrdenationItemProgress.id)}
      index={index}
    >
      {provided => (
        <DNDItemContainer
          provided={provided}
          text={text}
          image={image}
          altText={altText}
        >
          <ConditionalRenderer condition={!shouldShowAnswer}>
            <div
              {...provided.dragHandleProps}
              className={
                activityMode !== 'activity'
                  ? 'cursor-not-allowed'
                  : 'cursor-pointer'
              }
            >
              <DragIcon data-testid="dragIcon" />
            </div>
          </ConditionalRenderer>

          <ConditionalRenderer condition={shouldShowAnswer}>
            <span
              className={`h-6 w-6 md:h-8 md:w-8 rounded-full ${
                isCorrect ? 'bg-success' : 'bg-error'
              } text-base-100 text-14 md:text-16 shrink-0 flex items-center justify-center`}
            >
              <Text text={answerOrder + 'º'} format="rubik-500" />
            </span>
          </ConditionalRenderer>
        </DNDItemContainer>
      )}
    </Draggable>
  );
}
